import RootView from './rootView';

export default RootView;
